// extracted by mini-css-extract-plugin
export default {"header":"header_header__5jZgJ","share":"header_share__mQmed"};